import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13e10d17&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&setup=true&"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./index.vue?vue&type=style&index=0&id=13e10d17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e10d17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13e10d17')) {
      api.createRecord('13e10d17', component.options)
    } else {
      api.reload('13e10d17', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13e10d17&scoped=true&", function () {
      api.rerender('13e10d17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/info/lpu-about/index.vue"
export default component.exports